// extracted by mini-css-extract-plugin
export default {"bioInfo":"styles_bioInfo__pYTX7","infoPart":"styles_infoPart__VIED1","description":"styles_description__HptwA"};